// --------------------
// Static header (fallback)
// --------------------
const NewHeaderData = [
  { title: "Home", link: "/" },
  { title: "About Us", link: "/page/about-us" },
  { title: "Gallery Album", link: "/page/gallery&album" },
  { title: "Blog", link: "/page/blog" },

  // Dynamic services submenu will override this using "key"
  {
    title: "Our Services",
    key: "services", // IMPORTANT: Hook matches this
    link: "/page/our-services",
  },

  { title: "Our Products", link: "/page/categories" },
  { title: "F&Q", link: "/page/f&q" },
  { title: "Contact Us", link: "/page/contact-simple" },
];

export default NewHeaderData;

// --------------------
// Translation-support version
// --------------------
export const getTranslatedHeaderData = (t) => [
  {
    title: t("menu.home", "Home"),
    link: "/",
  },
  {
    title: t("menu.about", "About Us"),
    link: "/page/about-us",
  },
  {
    title: t("gallery_page.title", "Gallery Album"),
    link: "/page/gallery&album",
  },
  {
    title: t("menu.blogs", "Blog"),
    link: "/page/blog",
  },

  // Dynamic services list will be injected here
  {
    title: t("menu.services", "Our Services"),
    key: "services", // <-- MUST MATCH useHeaderData
    link: "/page/our-services",
  },

  {
    title: t("menu.porducts", "Our Products"),
    link: "/page/categories",
  },
  {
    title: t("menu.faq", "F&Q"),
    link: "/page/f&q",
  },
  {
    title: t("menu.contact", "Contact Us"),
    link: "/page/contact-simple",
  },
];
